var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('svg',[_c('use',{attrs:{"xlink:href":require("@/themes/novaporta/assets/icons/sprite.svg") + "#informationalIcon"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }